import React, { useEffect } from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import { useQuery } from "react-query";
import { Company, Scope } from "../models";
import ReportsService from "../service/ReportsService";
import { View360ReportTable } from "view360Card/components/view360ReportTable/View360ReportTable";
import pl from "shared/messages/pl";
import FailedToFetchReportError from "../error/FailedToFetchReportError";

export interface OtherParametersSubSectionProps {
    intermediaryId: number;
    scope: Scope | undefined;
    company: Company;
    selectedSegments: string[];
    selectedYears: string[];
    selectedMode: string;
}

export const OtherParametersSubSection: React.FC<OtherParametersSubSectionProps> = (props) => {
    const queryKey = `other_${props.company.code}`;

    const { isFetching, isError, data, refetch } = useQuery(queryKey, async () => {
        return await ReportsService.getOtherParametersReport(
            props.intermediaryId,
            props.scope,
            props.company.code,
            props.selectedSegments,
            props.selectedYears,
            props.selectedMode
        );
    });

    useEffect(() => {
        const init = async () => {
            await refetch();
        };

        init();
    }, [props.scope?.code, props.selectedSegments.length, props.selectedYears.length, props.selectedMode]);

    if (isError) {
        return (
            <FailedToFetchReportError
                message={pl.view360Card.reports.errors.failedToFetchOtherParametersReportErrorMessage(
                    props.company.name
                )}
            />
        );
    }

    return <View360ReportTable reportData={data} />;
};
